import { Option } from '../option';
import { ArrayOps } from '../lift';
/**
 * Flattens this Array of Arrays/Options.
 */
export function flatten() {
    var arr = this.value(), result = [];
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (Option.isOption(item))
            item.isDefined() && result.push(item.get());
        else
            result.push.apply(result, item);
    }
    return new ArrayOps(result);
}
ArrayOps.prototype.flatten = flatten;
